<template>
	<v-layout row justify-center>
		<v-dialog
			:fullscreen="fullscreen"
			v-model="edit.showModal"
			lazy
			max-width="700px"
			:transition="utils.getSettings('animation')"
			@keydown.esc="edit.showModal = false"
		>
			<v-card>
				<v-tabs v-model="active" color="blue darken-3" dark>
					<v-tab
						v-for="tab in tabs"
						:key="tab"
						:href="'#' + tab"
						v-if="tab === 'Gegevens' || selectedUser.id > 0"
						ripple
						>{{ tab }}
						{{
							tab === 'Historie' &&
							selectedUser.history &&
							selectedUser.history.length
								? '(' + selectedUser.history.length + ')'
								: ''
						}}</v-tab
					>
					<v-tabs-slider color="yellow"></v-tabs-slider>
					<v-tabs-items>
						<v-tab-item :key="'Gegevens'" :value="'Gegevens'">
							<v-card>
								<v-form v-model="valid" ref="form" lazy-validation>
									<v-card-title>
										<h2>
											{{
												selectedUser.id > 0
													? 'Wijzig gebruiker'
													: 'Nieuwe gebruiker'
											}}
											{{
												selectedUser.id > 0
													? ' #' + selectedUser.memberNumber
													: ''
											}}
										</h2>
									</v-card-title>
									<v-card-text>
										<v-container grid-list-md px-0 py-0>
											<v-layout wrap>
												<v-flex xs12>
													<v-radio-group
														v-model="customerType"
														v-if="showSelector"
													>
														<v-radio label="Nieuwe klant" value="new"></v-radio>
														<v-radio
															label="Gekoppelde klant"
															value="temp"
														></v-radio>
													</v-radio-group>
												</v-flex>
												<v-layout wrap xs12 v-if="customerType === 'new'">
													<v-flex xs6 sm6 md4>
														<v-select
															label="Aanhef"
															v-model="selectedUser.sex"
															:items="['Dhr.', 'Mevr.']"
														></v-select>
													</v-flex>
													<v-flex xs6 sm6 md4>
														<v-text-field
															label="Voornaam"
															required
															v-model="selectedUser.firstname"
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex xs12 sm6 md4>
														<v-text-field
															label="Achternaam"
															v-model="selectedUser.lastname"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex xs12 sm6>
														<v-text-field
															label="Bedrijfsnaam"
															v-model="selectedUser.companyname"
														></v-text-field>
													</v-flex>
													<v-flex xs12 sm6>
														<v-text-field
															label="Email"
															v-model="selectedUser.username"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex xs6 md6>
														<v-text-field
															label="Rijbewijsnummer"
															type="text"
															v-model="selectedUser.licenseid"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex xs6 md4>
														<v-text-field
															label="Geboortedatum"
															type="text"
															v-model="selectedUser.birthdate"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
														<v-flex xs6 md4>
															<v-text-field
																label="Vervaldatum rijbewijs"
																type="text"
																v-model="selectedUser.license_expiration_date"
																required
																:rules="basicRules"
															></v-text-field>
														</v-flex>
													<v-flex
														xs12
														v-if="
															selectedUser.id <= 0 && userType !== 'default'
														"
													>
														<v-text-field
															label="Wachtwoord"
															v-model="selectedUser.password"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex
														xs12
														v-if="selectedUser.id > 0 && userType !== 'default'"
													>
														<v-text-field
															label="Wachtwoord veranderen"
															v-model="selectedUser.newPassword"
														></v-text-field>
													</v-flex>
													<v-flex xs8>
														<v-text-field
															label="Woonplaats"
															type="text"
															v-model="selectedUser.city"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex xs4>
														<v-text-field
															label="Postcode"
															type="text"
															v-model="selectedUser.zip"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex xs9 md8>
														<v-text-field
															label="Adres"
															type="text"
															v-model="selectedUser.street"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex xs3>
														<v-text-field
															label="Huisnr"
															type="text"
															v-model="selectedUser.streetno"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex xs6>
														<v-text-field
															label="Telefoonummer"
															type="text"
															v-model="selectedUser.phoneno"
															required
															:rules="basicRules"
														></v-text-field>
													</v-flex>
													<v-flex xs6 sm4>
														<v-select
															label="Borg betaald"
															v-bind:items="selectItems"
															v-model="selectedUser.paid"
															item-text="text"
															item-value="value"
														></v-select>
													</v-flex>
													<v-flex xs6 sm4>
														<v-select
															label="Mag huren"
															v-bind:items="selectItems"
															v-model="selectedUser.canRent"
															item-text="text"
															item-value="value"
														></v-select>
													</v-flex>
													<v-flex xs6 sm4>
														<v-select
															v-model="selectedUser.active"
															v-bind:items="selectItems"
															label="Gebruiker actief"
															item-text="text"
															item-value="value"
														></v-select>
													</v-flex>
													<v-flex xs6 sm4>
														<v-text-field
															label="Tegoed"
															type="number"
															min="0"
															step="0.01"
															v-model="selectedUser.credit"
														></v-text-field>
													</v-flex>
												</v-layout>
											</v-layout>
											<v-layout v-if="customerType === 'temp'">
												<temp-customer
													:user="tempCustomer"
													:optional="false"
												></temp-customer>
											</v-layout>
										</v-container>
										<small>* Verplichte velden</small>
									</v-card-text>
								</v-form>
							</v-card>
						</v-tab-item>

						<v-tab-item :key="'Historie'" :value="'Historie'">
							<v-card>
								<v-card-title>
									<h2>Historie</h2>
								</v-card-title>
								<v-card-text>
									<v-layout wrap>
										<v-flex
											xs12
											v-if="selectedUser.history"
											class="text-xs-left"
										>
											<ul class="historyList">
												<li
													class="item"
													v-for="(item, index) in selectedUser.history"
													:key="item.rentId"
													@click="showHistory(item.rentId)"
												>
													<i class="right triangle icon"></i>
													<div class="content">
														<b class="header"
															>Fact. nr: {{ item.reservationNumber }}.
															{{ item.startDate }} t/m {{ item.endDate }}</b
														>
														<div class="description">
															&euro; {{ item.totalCosts | toCurrency }}
															{{ item.name }} - {{ item.mileage }} km.
															{{ item.remark }}
														</div>
													</div>
												</li>
											</ul>
											Totaal km: {{ totalKm }}
										</v-flex>
										<v-flex xs12 v-if="!selectedUser.history"
											>Geen historie</v-flex
										>
									</v-layout>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item :key="'Opties'" :value="'Opties'">
							<v-card>
								<v-card-title>
									<h2>Opties</h2>
								</v-card-title>
								<v-card-text>
									<v-container grid-list-md>
										<v-layout wrap>
											<v-btn
												color="red darken-1"
												flat
												@click.native="confirmDeleteDialog = true"
												>Verwijder gebruiker</v-btn
											>
										</v-layout>
									</v-container>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item :key="'Informatie'" :value="'Informatie'">
							<v-card>
								<v-card-title>
									<h2>Informatie</h2>
								</v-card-title>
								<v-card-text>
									<v-container grid-list-md>
										<v-layout wrap>
											<v-textarea
												name="remarks"
												label="Opmerkingen"
												value
												v-model="selectedUser.remarks"
											></v-textarea>
										</v-layout>
									</v-container>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item :key="'Gebruiker controleren'" :value="'Gebruiker controleren'">
							<v-card>
								<v-card-title>
									<h2>Gebruiker controleren</h2>
								</v-card-title>
								<v-card-text>
									<v-container grid-list-md class="px-0">
										<table-loader v-if="selectedUser.rentalCheck_status === 'pending'"></table-loader>
										<v-layout wrap>
											<v-btn
												color="primary"
												v-if="selectedUser.rentalCheck_status === ''"
												@click.native="checkUser()"
											>
												Doe externe controle
											</v-btn>
										</v-layout>
										<v-layout wrap mt-3 v-if="rentalCheckResult && !rentalCheckResult.registration">
											<v-flex xs12>
												<v-alert
													type="error"
													:value="true"
												>{{ rentalCheckResult }}</v-alert>
											</v-flex>
										</v-layout>
										<v-layout wrap mt-3 v-if="rentalCheckPhotos.length > 0">
											<v-flex xs12>
												<v-layout wrap align-center>
													<v-btn color="primary" flat @click.native="downloadRentalCheckPhotos()">
														Download foto's
													</v-btn>
													<v-btn color="red darken-1" flat @click.native="deleteRentalCheckPhotos()">
														Verwijder foto's
													</v-btn>
												</v-layout>
											</v-flex>
											<v-flex xs12>
												<h3>Rijbewijsfoto's</h3>
											</v-flex>
											<v-flex xs12>
												<v-layout wrap>
													<v-flex xs6 sm4 md4 v-for="photo in rentalCheckPhotos" :key="photo.id">
														<v-card>
															<img :src="photo.url" style="width: 164px;" contain>
															<v-card-text v-if="photo.filename">
																<small>{{ photo.filename }}</small>
															</v-card-text>
														</v-card>
													</v-flex>
												</v-layout>
											</v-flex>
										</v-layout>
										<!-- Mobile: Card layout -->
										<v-layout wrap mt-3 v-if="rentalCheckExecutions.length > 0" class="hidden-sm-and-up">
											<v-flex xs12>
												<h3>Checks</h3>
											</v-flex>
											<v-flex xs12 v-for="execution in rentalCheckExecutions" :key="execution.id">
												<v-card class="check-card">
													<v-card-text>
														<div class="check-item">
															<span class="check-label">Type:</span>
															<span class="check-value">{{ execution.type }}</span>
														</div>
														<div class="check-item">
															<span class="check-label">Uitgevoerd op:</span>
															<span class="check-value">{{ formatExecutionDate(execution.performed_at) }}</span>
														</div>
														<div class="check-item">
															<span class="check-label">Status:</span>
															<span class="check-value" :class="'status-' + execution.status">{{ execution.status }}</span>
														</div>
														<div class="check-item">
															<span class="check-label">Bericht:</span>
															<span class="check-value">{{ execution.message }}</span>
														</div>
														<div class="check-item" v-if="execution.pdf_report_url || execution.html_report_url">
															<span class="check-label">Rapporten:</span>
															<span class="check-value">
																<a
																	v-if="execution.pdf_report_url"
																	href="#"
																	@click.prevent="openRentalCheckReport(execution.pdf_report_url, 'pdf')"
																	rel="noopener noreferrer"
																>
																	PDF
																</a>
																<span v-if="execution.pdf_report_url && execution.html_report_url"> | </span>
																<a
																	v-if="execution.html_report_url"
																	href="#"
																	@click.prevent="openRentalCheckReport(execution.html_report_url, 'html')"
																	rel="noopener noreferrer"
																>
																	HTML
																</a>
															</span>
														</div>
													</v-card-text>
												</v-card>
											</v-flex>
										</v-layout>

										<!-- Desktop: Table layout -->
										<v-layout wrap mt-3 v-if="rentalCheckExecutions.length > 0" class="hidden-xs-only">
											<v-flex xs12>
												<h3>Checks</h3>
												<table class="checks-table">
													<thead>
														<tr>
															<th>Type</th>
															<th>Uitgevoerd op</th>
															<th>Status</th>
															<th>Bericht</th>
															<th>Rapporten</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="execution in rentalCheckExecutions" :key="execution.id">
															<td>{{ execution.type }}</td>
															<td>{{ formatExecutionDate(execution.performed_at) }}</td>
															<td>{{ execution.status }}</td>
															<td>{{ execution.message }}</td>
															<td>
																<a
																	v-if="execution.pdf_report_url"
																	href="#"
																	@click.prevent="openRentalCheckReport(execution.pdf_report_url, 'pdf')"
																	rel="noopener noreferrer"
																>
																	PDF
																</a>
																<span v-if="execution.pdf_report_url && execution.html_report_url"> | </span>
																<a
																	v-if="execution.html_report_url"
																	href="#"
																	@click.prevent="openRentalCheckReport(execution.html_report_url, 'html')"
																	rel="noopener noreferrer"
																>
																	HTML
																</a>
															</td>
														</tr>
													</tbody>
												</table>
											</v-flex>
										</v-layout>
									</v-container>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-layout row wrap>
							<v-flex xs8>
								<v-btn color="darken-1" flat @click.native="closeModal()"
									>Sluiten</v-btn
								>
							</v-flex>
							<v-flex xs4 text-xs-right>
								<v-btn color="primary darken-1" @click.native="updateUser()"
									>Opslaan</v-btn
								>
							</v-flex>
						</v-layout>
					</v-tabs-items>
				</v-tabs>
			</v-card>
		</v-dialog>
		<v-dialog v-model="confirmDeleteDialog" max-width="290">
			<v-card>
				<v-card-title class="headline">Weet u het zeker?</v-card-title>
				<v-card-text
					>Klik op bevestigen om de gebruiker te verwijderen.</v-card-text
				>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="gray darken-1"
						flat="flat"
						@click.native="confirmDeleteDialog = false"
						>Annuleren</v-btn
					>
					<v-btn color="primary" @click.native="deleteUser()">Bevestigen</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>
<script>
class UserModel {
	construct(data) {
		this.data = data;
	}

	name() {
		return this.data.firstname + ' ' + this.data.lastname;
	}

	// and so on, put other methods here
}
import * as utils from '@/utils/utils';
import axios from 'axios';
import moment from 'moment';
import userModel from '@/models/user.js';
import TableLoader from '@/components/TableLoader';
import TempCustomer from '@/components/subcomponents/TempCustomer';

export default {
	name: 'UserModal',
	components: { TempCustomer, TableLoader },
	created: function() {
		if (window.innerHeight < 750 && window.innerWidth < 750) {
			this.fullscreen = true;
		}
		this.userType = localStorage.getItem('t');
	},
	data() {
		return {
			tabs: ['Gegevens', 'Historie', 'Opties', 'Informatie', 'Gebruiker controleren'],
			selectItems: [
				{
					text: 'Ja',
					value: '1'
				},
				{
					text: 'Nee',
					value: '0'
				}
			],
			active: 0,
			confirmDeleteDialog: false,
			dialog: false,
			dialog2: false,
			dialog3: false,
			utils: utils,
			sound: true,
			widgets: false,
			unitDate: {},
			selectedUser: {},
			tempCustomer: {},
			test: {},
			customerType: 'new',
			emailRules: [
				v => !!v || 'E-mail is verplicht',
				v =>
					/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					'E-mailadres is niet correct'
			],
			basicRules: [v => !!v || 'Verplicht veld'],
			valid: false,
			fullscreen: false,
			userType: 'default',
			rentalCheckResult: null,
			rentalCheckPhotos: [],
			rentalCheckUserStatusResponse: null,
			rentalCheckStatusInterval: null
		};
	},
	computed: {
		totalKm() {
			let sum = this.selectedUser.history.reduce((s, f) => {
				return parseFloat(f.mileage) + s; // return the sum of the accumulator and the current time. (as the the new accumulator)
			}, 0);
			return this.utils.getFormattedAmount(sum.toFixed(2));
		},
		rentalCheckExecutions() {
			const response = this.rentalCheckUserStatusResponse;
			if (
				response &&
				response.registration &&
				Array.isArray(response.registration.check_executions)
			) {
				return response.registration.check_executions;
			}
			return [];
		}
	},
	props: ['user', 'edit', 'id', 'showSelector'],
	watch: {
		active(newVal) {
			if (newVal === 'Gebruiker controleren' && this.id > 0) {
				this.getRentalCheckPhotos();
				if (
					this.selectedUser &&
					typeof this.selectedUser.rentalCheck_status === 'string' &&
					this.selectedUser.rentalCheck_status.toLowerCase() !== ''
				) {
					this.getRentalCheckUserStatus();
				}
			}
		},
		'edit.showModal'(newVal) {
			if (newVal) {
				this.active = 'Gegevens';
			} else if (this.rentalCheckStatusInterval) {
				clearInterval(this.rentalCheckStatusInterval);
				this.rentalCheckStatusInterval = null;
			}
		},
		id(newVal) {
			var self = this;
			self.active = 'Gegevens';
			self.rentalCheckResult = null;
			self.rentalCheckPhotos = [];
			self.rentalCheckUserStatusResponse = null;
			// Clear polling interval when user changes
			if (self.rentalCheckStatusInterval) {
				clearInterval(self.rentalCheckStatusInterval);
				self.rentalCheckStatusInterval = null;
			}

			if (this.id > 0) {
				utils
					.getData(basePath + 'api/users/getUser/' + this.id)
					.then(function(json) {
						//self.test = new userModel(json.data[0]);
						self.selectedUser = json.data[0];
						self.selectedUser.birthdate = self.selectedUser.birthdate
							? moment(self.selectedUser.birthdate, 'YYYY-MM-DD').format(
									'DD-MM-YYYY'
							  )
							: '';
						if (self.selectedUser.birthdate === 'Invalid date') {
							self.selectedUser.birthdate = '';
						}
						self.selectedUser.license_expiration_date = self.selectedUser
							.license_expiration_date
							? moment(
										self.selectedUser.license_expiration_date,
										'YYYY-MM-DD'
							  ).format('DD-MM-YYYY')
							: '';
						if (self.selectedUser.license_expiration_date === 'Invalid date') {
							self.selectedUser.license_expiration_date = '';
						}
						self.selectedUser.history = json.history;
					});
			} else {
				if (self.$refs.form) {
					self.$refs.form.reset();
				}
				self.selectedUser = this.user;
				self.firstname = '';
				self.lastname = '';
			}
		},
		'selectedUser.rentalCheck_status'(newVal) {
			if (newVal !== '' && newVal.toLowerCase() === 'pending') {
				// Start polling interval if not already running
				if (!this.rentalCheckStatusInterval) {
					this.rentalCheckStatusInterval = setInterval(() => {
						this.getRentalCheckUserStatus();
					}, 5000);
				}
			} else {
				// Clear interval if status is no longer pending
				if (this.rentalCheckStatusInterval) {
					clearInterval(this.rentalCheckStatusInterval);
					this.rentalCheckStatusInterval = null;
				}
		}
	},

	},

	methods: {
		newUser() {
			this.selectedUser = {
				discount: '0',
				active: '1',
				canRent: '1',
				paid: '1'
			};
			this.tempCustomer = {};
			this.edit.showModal = true;
		},
		closeModal() {
			this.edit.showModal = false;
		},
		updateModel() {
			window.emitter.$emit('showToastMessage', { msg: 'Gegevens opgeslagen' });
		},
		updateUser() {
			var self = this;
			if (this.customerType === 'new') {
				var data = {
					user: {
						paid: this.selectedUser.paid,
						active: this.selectedUser.active,
						canRent: this.selectedUser.canRent,
						remark: this.selectedUser.remark,
						username: this.selectedUser.username,
						credit: this.selectedUser.credit
					},
					userDetails: {
						firstname: this.selectedUser.firstname,
						lastname: this.selectedUser.lastname,
						companyname: this.selectedUser.companyname,
						street: this.selectedUser.street,
						streetno: this.selectedUser.streetno,
						licenseid: this.selectedUser.licenseid,
						zip: this.selectedUser.zip,
						city: this.selectedUser.city,
						phoneno: this.selectedUser.phoneno,
						remarks: this.selectedUser.remarks,
						license_expiration_date: moment(
							self.selectedUser.license_expiration_date,
							'DD-MM-YYYY'
						).format('YYYY-MM-DD'),
						birthdate: moment(self.selectedUser.birthdate, 'DD-MM-YYYY').format(
							'YYYY-MM-DD'
						)
					}
				};
			} else {
				var data = this.selectedUser;
			}
			// Existing user
			if (this.id > 0) {
				data.newPassword = this.selectedUser.newPassword;
			} else {
				data.password = this.selectedUser.password;
			}

			if (this.$refs.form.validate()) {
				const apiType = this.customerType === 'new' ? 'User' : 'TempUser';

				// Update
				if (this.id > 0) {
					utils
						.setData(
							basePath + 'api/users/update' + apiType + '/' + this.id,
							data
						)
						.then(function(json) {
							self.updateModel();
							self.$emit('userUpdated');
							self.edit.showModal = false;
						});
				} else {
					// New user
					utils
						.setData(basePath + 'api/users/create' + apiType + '/', data)
						.then(function(json) {
							self.updateModel();
							self.edit.showModal = false;
							self.$emit('userUpdated');

							if (json.data && json.data[0]) {
								window.emitter.$emit('userCreated', {
									type: self.customerType,
									tempCustomer: self.tempCustomer,
									user: json.data
								});
							}
						});
				}
			}
		},
		showHistory(id) {
			window.location.href = '#/history/' + id;
		},
		deleteUser() {
			utils.getData(basePath + 'api/users/delete/' + this.id).then(json => {
				this.confirmDeleteDialog = false;
				this.edit.showModal = false;
				this.updateModel();
				this.$emit('userUpdated');
			});
		},
		downloadRentalCheckPhotos() {
			var token = localStorage.getItem('b');
			var payload = {};

			if (token) {
				payload.b = token;
			}

			axios
				.post(
					basePath + 'api/rentalcheck/downloadphotos/' + this.id,
					JSON.stringify(payload),
					{
						responseType: 'blob'
					}
				)
				.then(response => {
					var downloadUrl = window.URL.createObjectURL(response.data);
					var link = document.createElement('a');
					link.href = downloadUrl;
					link.download = 'rentalcheck-photos-' + this.id + '.zip';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(downloadUrl);
				});
		},
		deleteRentalCheckPhotos() {
			var self = this;
			utils
				.setData(basePath + 'api/rentalcheck/deletephotos/' + this.id, {})
				.then(function() {
					self.rentalCheckPhotos = [];
					window.emitter.$emit('showToastMessage', {
						msg: "Foto's verwijderd"
					});
				});
		},
		openRentalCheckReport(url, fileType) {
			if (!url) {
				return;
			}

			var token = localStorage.getItem('b');
			var payload = {
				url: url,
				fileType: fileType
			};

			if (token) {
				payload.b = token;
			}

			axios
				.post(basePath + 'api/rentalcheck/proxydocument', JSON.stringify(payload), {
					responseType: 'blob'
				})
				.then(response => {
					var mimeType = fileType === 'pdf' ? 'application/pdf' : 'text/html';
					var blob = new Blob([response.data], { type: mimeType });
					var documentUrl = window.URL.createObjectURL(blob);
					window.open(documentUrl, '_blank');
					setTimeout(function() {
						window.URL.revokeObjectURL(documentUrl);
					}, 1000);
				})
				.catch(() => {
					window.emitter.$emit('showToastMessage', {
						msg: 'Kon rapport niet openen'
					});
				});
		},
		checkUser() {
			var self = this;
			self.selectedUser.rentalCheck_status = 'queued';
			utils.setData(basePath + 'api/rentalcheck/register/', {user_id: this.id}).then(json => {
				if (json) {
					self.rentalCheckResult = json;
			
					if (json && json.status !== 500) {
						self.selectedUser.rentalCheck_status = 'pending';
					}
				}
			});
		},
		getRentalCheckPhotos() {
			var self = this;
			utils.getData(basePath + 'api/rentalcheck/photos/' + this.id).then(json => {
				const responseData =
					json && json.data && typeof json.data === 'object' ? json.data : json;
				if (responseData && typeof responseData === 'object') {
					// Transform response { front: {...}, back: {...} } to array for UI
					const photos = [];
				
					Object.keys(responseData).forEach(key => {
						const photo = responseData[key];
						if (photo && photo.found && photo.filename) {
							photos.push({
								id: key,
								label: key.charAt(0).toUpperCase() + key.slice(1),
								filename: photo.filename,
								mime: photo.mime,
								url: photo.url
							});
						}
					});
					self.rentalCheckPhotos = photos;
				}
			});
		},
		getRentalCheckUserStatus() {
			var self = this;
			utils.getData(basePath + 'api/rentalcheck/userstatus/' + this.id).then(json => {
				self.rentalCheckUserStatusResponse =
					json && json.data !== undefined ? json.data : json;
				if (
					self.rentalCheckUserStatusResponse && self.rentalCheckUserStatusResponse.registration &&
					self.rentalCheckUserStatusResponse.registration.status !== 'unknown' &&
					self.rentalCheckStatusInterval
				) {
					clearInterval(self.rentalCheckStatusInterval);
					self.rentalCheckStatusInterval = null;
				}
			});
		},
		formatExecutionDate(value) {
			if (!value) {
				return '';
			}
			const formatted = moment(value).format('DD-MM-YYYY HH:mm:ss');
			return formatted === 'Invalid date' ? value : formatted;
		}
	},
	beforeDestroy() {
		// Clean up polling interval
		if (this.rentalCheckStatusInterval) {
			clearInterval(this.rentalCheckStatusInterval);
			this.rentalCheckStatusInterval = null;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.historyList {
	list-style-type: none;
	padding: 0;
	margin: 0;
	width: 100%;
	li {
		display: inline-block;
		margin: 0 10px;
		border-bottom: solid 1px #eee;
		width: 100%;
		padding: 5px 0;
		margin: 0;
		cursor: pointer;

		&:hover {
			opacity: 0.7;
		}
	}
}

.checks-table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 12px;

	thead {
		background-color: #f5f5f5;
	}

	th,
	td {
		padding: 8px 12px;
		text-align: left;
		border-bottom: 1px solid #ddd;
		font-size: 12px;
	}

	th {
		font-weight: 600;
		color: #333;
	}

	tbody tr:hover {
		background-color: #fafafa;
	}

	a {
		color: #1976d2;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
}

.check-card {
	margin-bottom: 12px;
	background-color: #fafafa;

	&:last-child {
		margin-bottom: 0;
	}
}

.check-item {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 12px;
	padding: 8px 0;
	border-bottom: 1px solid #eee;

	&:last-child {
		border-bottom: none;
		margin-bottom: 0;
	}

	@media (max-width: 600px) {
		flex-direction: column;
	}
}

.check-label {
	font-weight: 600;
	color: #333;
	min-width: 120px;
	margin-right: 16px;

	@media (max-width: 600px) {
		display: block;
		margin-right: 0;
		margin-bottom: 4px;
		font-size: 12px;
		color: #666;
	}
}

.check-value {
	flex: 1;
	word-break: break-word;
	color: #333;
	font-size: 14px;

	a {
		color: #1976d2;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	&.status-valid {
		color: #4caf50;
		font-weight: 600;
	}

	&.status-invalid {
		color: #f44336;
		font-weight: 600;
	}

	&.status-pending {
		color: #ff9800;
		font-weight: 600;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Users/UserModal.vue